import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography';
import { Line } from 'react-chartjs-2';
import { CommonBadgeGenerate } from '../Components/commonBadge'

const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },

    card: {
        flexGrow: 1,
        backgroundColor: "#ffffff",
        paddingInlineStart: '10px',
        borderRadius: '10px',
        boxShadow: ' 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
        widht: 'auto',
        height: 'auto',
        marginTop: 30
    },

    titleSecondary: {
        fontSize: 15,
        alignContent: 'center'
    },

});


export const ChartEstatetCollectionByDayGrid = ({ chartdata }) => {
    const classes = useStyles();

    return (

        <Card className={classes.card} boxShadow={3} >

            <CardContent>
                <CommonBadgeGenerate
                    cardTitle={
                        <Typography className={classes.titleSecondary} color="textSecondary" gutterBottom>
                            <b>Estate Collection By Day</b>
                        </Typography>
                    }
                    badgeName={"E"}
                />

                <Line
                    data={chartdata}
                    options={{
                        responsive: true,
                        maintainAspectRatio: true
                    }}
                />

            </CardContent>

        </Card>

    );

}